<template>
    <div>
        <v-label class="pb-2">{{label}}</v-label>
        <v-data-table
            :headers="headers"
            :items="rows"
            :items-per-page="5"
            class="elevation-1 mt-2 "
        >
            <template v-slot:top>
                <v-toolbar flat>
                    <v-spacer></v-spacer>
                    <v-btn
                        class="mt-2"
                        color="primary"
                        dark
                        @click="createItem"
                    >
                        Agregar elemento
                    </v-btn>
                </v-toolbar>
            </template>

            <template v-slot:item="{item}">
                <tr>
                    <td v-for="(tableField, index) in headers" :key="'field_'+index">
                        <template v-if="isImageField(index) && item[tableField.value]">
                            <v-btn text>
                                <v-img
                                    :lazy-src="item[tableField.value].url"
                                    max-height="30"
                                    max-width="50"
                                    :src="item[tableField.value].url"
                                    @click="downloadFile(item[tableField.value].url)"
                                    pointer-events-auto
                                ></v-img>
                            </v-btn>

                        </template>
                        <template v-else-if="isFileField(index)  && item[tableField.value]">
                            <v-btn
                                color="primary" text small
                                @click="downloadFile(item[tableField.value].url)"
                                :title="item[tableField.value].fileName"
                            >
                                {{getTruncatedFileName(item[tableField.value].file_name)}}
                            </v-btn>
                        </template>
                        <template v-else-if="isSelectOrRadio(index)  && item[tableField.value]">
                            {{item[tableField.value].label}}
                        </template>
                        <template v-else-if="isCheckbox(index)">
                            {{ getCorrectDataForCheckbox(item[tableField.value])}}
                        </template>
                        <template v-else-if="tableField.value === 'acciones'  && item[tableField.value]">

                            <v-tooltip left v-for="(action) in item.acciones" :key="action">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        :color="action == 'delete'? 'error': 'primary'"
                                        class="mr-1"
                                        outlined
                                        @click="executeEventAction(action, item)"
                                        v-bind="attrs"
                                        v-on="on"
                                        small
                                    >
                                        <v-icon class="mr-0" left v-if="action=='edit'" small>fas fa-pen</v-icon>
                                        <v-icon class="mr-0" left v-if="action=='delete'" small>fas fa-trash</v-icon>
                                    </v-btn>
                                </template>
                                <span v-if="action==='edit'"> Editar</span>
                                <span v-else>Eliminar</span>
                            </v-tooltip>


                        </template>
                        <template v-else-if="item[tableField.value]">
                            {{item[tableField.value]}}
                        </template>
                    </td>
                </tr>

            </template>
        </v-data-table>



        <v-dialog
            v-if="showFormDialog"
            v-model="showFormDialog"
            persistent
            max-width="1000px"
            scrollable
        >
            <v-card>
                <v-card-title>
                    <span class="headline">{{field.etiqueta}}</span>
                    <div class="d-flex justify-end  flex-fill">
                        <v-btn
                            icon
                            @click="showFormDialog = false"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-card-title>
                <v-card-text>
                    <!-- <FormComponent procedure-action="execute" /> -->
                    <v-form
                        ref="tableDynamicForm"
                        v-model="formValid"
                    >
                        <v-row v-if="valuesInit">
                            <template v-for="formField in field.modal_form">
                                <v-col
                                   :cols="getColSize(formField, 'xs')"
                                    :sm="getColSize(formField, 'sm')"
                                    :md="getColSize(formField, 'md')"
                                    :lg="getColSize(formField, 'lg')"
                                    :key="formField.id"
                                    v-if="validDependent(formField)"
                                >

                                     <label v-if=" formField.tipo  !=  'javascript' 
                                            && formField.tipo != 'paragraph' 
                                            && formField.tipo != 'subtitle' 
                                            && formField.tipo != 'title' 
                                            && formField.tipo != 'variable' 
                                            && formField.tipo != 'cart' 
                                            && formField.tipo != 'map'
                                            && formField.tipo != '<span> </span>'
                                            && formField.etiqueta != '<span></span>'" class="text-family">
                                            {{getLabel(formField)}}
                                    </label>

                                    <ParagraphField
                                        v-if="formField.tipo === 'paragraph'"
                                        :field="formField"
                                    />
                                    <SubtitleField
                                        v-if="formField.tipo === 'subtitle'"
                                        :field="formField"
                                    />
                                    <TextField
                                        v-if="formField.tipo === 'text'"
                                        :field="formField"
                                        :readonly="validateFieldReadOnly(formField)"
                                        :default_value="validateDefaultValue(formField)"
                                        :formValues="TDFormValues"
                                        :api-ajax="findApiAjaxDependent(formField)"
                                    />
                                    <TextArea
                                        v-if="formField.tipo === 'textarea'"
                                        :field="formField"
                                        :readonly="validateFieldReadOnly(formField)"
                                        :default_value="validateDefaultValue(formField)"
                                        :formValues="TDFormValues"
                                    />
                                    <SelectField
                                        v-if="formField.tipo === 'select'"
                                        :field="formField"
                                        :readonly="validateFieldReadOnly(formField)"
                                        :default_value="validateDefaultValue(formField)"
                                        :stageId="procedureMeta.etapa_id"
                                        :formValues="TDFormValues"
                                        :dynamic-table="true"
                                    />
                                    <DateField
                                        v-if="formField.tipo === 'date'"
                                        :field="formField"
                                        :readonly="validateFieldReadOnly(formField)"
                                        :default_value="validateDefaultValue(formField)"
                                        :formValues="TDFormValues"
                                    />
                                    <CheckboxField
                                        v-if="formField.tipo === 'checkbox'"
                                        :field="formField"
                                        :readonly="validateFieldReadOnly(formField)"
                                        :default_value="validateDefaultValue(formField)"
                                        :formValues="TDFormValues"
                                        :dynamic-table="true"
                                    />
                                    <RadioField
                                        v-if="formField.tipo === 'radio'"
                                        :field="formField"
                                        :readonly="validateFieldReadOnly(formField)"
                                        :default_value="{ value: validateDefaultValue(formField)}"
                                        :formValues="TDFormValues"
                                        :dynamic-table="true"
                                    />
                                    <FileField
                                        v-if="formField.tipo === 'file'"
                                        :field="formField"
                                        :readonly="validateFieldReadOnly(formField)"
                                        :default_value="validateDefaultValue(formField)"
                                        :formValues="TDFormValues"
                                        :dynamic-table="true"
                                        :row="rowForFile"
                                    />
                                    <ApiAjaxField
                                        v-if="formField.tipo === 'api_ajax'"
                                        :field="formField"
                                        :formValues="TDFormValues"
                                        :stage-id="procedureMeta.etapa_id"
                                    />
                                    <MapField
                                        v-if="formField.tipo === 'map'"
                                        :field="formField"
                                        :readonly="validateFieldReadOnly(formField)"
                                        :default_value="validateDefaultValue(formField)"
                                        :formValues="TDFormValues"
                                    />
                                </v-col>
                            </template>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="secondary"
                        outlined
                        @click="closeEdit()"
                    >
                        Cerrar
                    </v-btn>
                    <v-btn
                        outlined
                        color="primary"
                        @click="saveItemData()"
                    >
                        Guardar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="900px">
            <v-card>
                <v-card-title class="headline">¿Está seguro de eliminar el elemento?</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" outlined @click="closeDelete">Cancelar</v-btn>
                    <v-btn color="primary" outlined @click="deleteItemConfirm">Eliminar</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>

</template>

<script>

import Vue from 'vue'
import {expresionToArray, bootstrapSizeToVuetify} from "bestgob-core/core/utils";
import evaluate from "simple-evaluate";
import {mapActions, mapGetters, mapState} from "vuex";
import moment from 'moment';
// import FormComponent from '../Form.vue'

export default {
    name: "TableDynamic",
    props: ['field', 'readonly', 'label', 'formValues'],
    computed: {
        ...mapState({proceduresStore: state => state.procedures}),
        ...mapGetters('procedures', [ 'procedureMeta', 'procedureData', 'returnLastCondition'])
    },

    components: {
        // FormComponent,
        TextField: () => import('./Text.vue'),
        TextArea: () => import('./TextArea.vue'),
        ParagraphField: () => import('./Paragraph.vue'),
        SubtitleField: () => import('./Subtitle.vue'),
        SelectField: () => import('./Select.vue'),
        CheckboxField: () => import('./Checkbox.vue'),
        RadioField: () => import('./Radio.vue'),
        DateField: () => import('./Date.vue'),
        FileField: () => import('./File.vue'),
        ApiAjaxField: () => import('./ApiAjax'),
        MapField: ()=> import('./Map.vue')
    },

    data(){
        return {
            showFormDialog: false,
            headers: [],
            rows: [],

            formValid: false,
            TDFormValues: {},
            valuesInit: false,

            currentItemEditing: -1,
            dialogDelete: false,

            //Se usa cuando se suben archivos dentro de la tabla dinamica, ell webservices
            //aparte de la etapa, campo hay diferenciar a que fila de la tabla pertenece
            rowForFile: 0,

            apiAjaxComponents: {

            },
            lastConditionDefault: [],
        }
    },

    mounted() {
        this.addTableHeaders()
        this.initEmptyFormValues()
        this.initTableValues()
    },

    methods: {
        ...mapActions('procedures', ['setLastCondition']),

        getColSize(field, size){
            let bootstrapSizes = ''
            if (field.extra != null && field.extra.tamano != null){
                bootstrapSizes = field.extra.tamano
            }

            return bootstrapSizeToVuetify(bootstrapSizes, size)
        },
        
        addTableHeaders(){
            this.field.datos.th.forEach((header, index) => {
                this.headers.push({text: header, value: this.field.datos.td[index]})
            })

            this.headers.push({text: 'Acciones', value: 'acciones'})
        },

        initTableValues(){
            if (this.formValues[this.field.nombre] && this.formValues[this.field.nombre] != 'null'){
                let parsedRows = JSON.parse(this.formValues[this.field.nombre])
                if (!Array.isArray(parsedRows)){
                    parsedRows = Object.values(parsedRows)
                }

                parsedRows.forEach(row => {
                    row['acciones'] = this.getItemActions()
                })

                this.rows = parsedRows
            }
        },

        saveItemData(){
            let isValid = this.$refs.tableDynamicForm.validate();

            if (isValid){
                // Create new Item
                this.serializeCheckboxValue(this.TDFormValues)

                if (this.currentItemEditing === -1){
                    this.rows.push(this.TDFormValues)
                }
                // Update item
                else{
                    Object.assign(this.rows[this.currentItemEditing], this.TDFormValues)
                    this.currentItemEditing = -1
                }

                this.showFormDialog = false
                this.initEmptyFormValues()

                this.formValues[this.field.nombre] = JSON.stringify(this.rows)
            }
        },

        executeEventAction(action, item){
            if (action === 'edit'){
                this.editItem(item)
            }
            else if (action === 'delete'){
                this.deleteItem(item)
            }
        },

        createItem(){
            this.currentItemEditing = -1
            this.getRowForFileComponent()
            this.showFormDialog = true
        },

        editItem (item) {
            this.currentItemEditing = this.rows.indexOf(item)
            this.TDFormValues = Object.assign({}, item)
            this.getRowForFileComponent()
            this.showFormDialog = true
        },

        closeEdit(){
            this.showFormDialog = false
            this.$nextTick(() => {
                this.initEmptyFormValues()
                this.currentItemEditing = -1
            })
        },

        deleteItem (item) {
            this.currentItemEditing = this.rows.indexOf(item)
            this.TDFormValues = Object.assign({}, item)
            this.dialogDelete = true
        },

        deleteItemConfirm () {
            this.rows.splice(this.currentItemEditing, 1)
            this.closeDelete()
        },

        closeDelete () {
            this.dialogDelete = false
            this.$nextTick(() => {
                this.initEmptyFormValues()
                this.currentItemEditing = -1
            })
        },

        initEmptyFormValues(){
            this.TDFormValues = {}

            // Add Values with null
            this.field.modal_form.forEach((formField) => {
                if (formField.tipo === 'api_ajax'){
                    this.addAndPrepareApiAjax(formField)
                }else{
                    Vue.set(this.TDFormValues, formField.nombre, formField.value)
                }
            })

            //Add Actions
            this.TDFormValues['acciones'] = this.getItemActions()
            this.valuesInit = true
        },

        getItemActions(){
            let actions = []

            if (this.field.extra.button_edit_modal){
                actions.push('edit')
            }
            if (this.field.extra.button_delete_modal){
                actions.push('delete')
            }

            return actions
        },

        isImageField(index){
            return this.field.datos.type[index] === 'image'
        },

        isFileField(index){
            return this.field.datos.type[index] === 'file'
        },

        isSelectOrRadio(index){
            return this.field.datos.type[index] === 'select' || this.field.datos.type[index] === 'radio'
        },

        isCheckbox(index){
            return this.field.datos.type[index] === 'checkbox'
        },

        serializeCheckboxValue(){
            this.field.datos.type.forEach((value, index) => {
                if (value === 'checkbox'){
                    let key = this.field.datos.td[index]
                    this.TDFormValues[key] = JSON.stringify(this.TDFormValues[key])
                }
            })
        },

        getCorrectDataForCheckbox(data){
            if (Array.isArray(data)){
                return data.join(' ')
            }

            return JSON.parse(data).join(' ')
        },

        downloadFile(file){
            window.open(file)
        },

        getTruncatedFileName(fileName){
            let parts = fileName.split('.')

            if (parts.length === 2 && parts[0].length > 10){
                return parts[0].slice(0, 10)+'...'+parts[1]
            }

            return fileName
        },

        getRowForFileComponent(){
            this.rowForFile = this.currentItemEditing === -1 ?
                this.rows.length : this.currentItemEditing
        },

        /** ------- FORM ITEMS CREATOR ------- **/
        validDependent(field){
            if (field.dependiente_campo != null && field.dependiente_campo != ''){
                return this.evaluateDependentExpresion(field.dependiente_campo)
            }

            return true
        },

        validateFieldReadOnly(field){
            if (field.condicion_solo_lectura != null && field.condicion_solo_lectura != ''){
                return (field.readonly == 1 && this.evaluateDependentExpresion(field.condicion_solo_lectura))
            }

            return (field.readonly == 1)
        },

        validateDefaultValue(field){
            // console.log(field);
            // field.condicion_valor_default ? (console.log(field.etiqueta, this.formValues[field.nombre] )) : 0 ;
            //valida que la condicion por default exista
            if ( field.condicion_valor_default != null && field.condicion_valor_default != ''){
                
                //evalua la condiccion y trae true o false dependiendo del resultado
                let isValid = this.evaluateDependentExpresion(field.condicion_valor_default);
                // console.log(isValid);
                //para poner entrara  acambiar el valor es necesario la validacion anterior cambie, asi se previene que se quiera actualizar en cada cambio de valor
                // console.log(this.lastConditionDefault);
                // console.log(isValid);
                if(this.returnLastCondition[field.nombre] != isValid ){
                    //si la condicion se cumple siempre cambia el valor del campo, (this.formValues[field.nombre] a el valor por default)
                    if (isValid){
                        console.log(this.getVariableExpresionValue(field.valor_default, field.tipo));
                        this.formValues[field.nombre] = this.getVariableExpresionValue(field.valor_default, field.tipo)
                        console.log(this.formValues[field.nombre]);
                    }
                    else if (  !isValid && field.valor_default_no_cumple != null  ){
                        //date no estaba agarrando valor vacio o '' , entonces opte por poner la fecha actual
                        if( field.tipo == 'date' && field.valor_default_no_cumple == '' ){
                            this.formValues[field.nombre]= moment(new Date).format('YYYY-MM-DD')
                        }else{
                            this.formValues[field.nombre]= this.getVariableExpresionValue(field.valor_default_no_cumple)

                        }
                    }
                }
                this.lastConditionDefault[field.nombre] = isValid
                this.setLastCondition( { nombre: field.nombre , isValid: isValid})
            }
        },

        evaluateDependentExpresion(originalExpression) {
            let expression = originalExpression.replace(/ and /g, " && ").replace(/ or /g, ' || ')
            let expressionArray = expresionToArray(expression)

            for (let i = 0; i < expressionArray.length; i++) {
                if (expressionArray[i].includes('@@')) {
                    let fieldToCompare = expressionArray[i].trim().replace('@@', '')
                    let comparisonValue = this.TDFormValues[fieldToCompare]

                    if (comparisonValue === undefined) {
                        comparisonValue = this.getValueFromProcessData(fieldToCompare)
                    }

                    expression = expression.replace(expressionArray[i], `'${comparisonValue}'`)
                    console.log(expression)
                }
            }

            return evaluate(null, expression)
        },

        getVariableExpresionValue(variableExpresion, tipo){
            console.log(tipo);
            console.log(variableExpresion);
             if (variableExpresion?.includes('@@') || variableExpresion?.includes('@!')){
                 console.log('here');
                    let variableName;
                    let hasBeentrimed = false;
                    if(variableExpresion?.includes('@!')){
                        variableName = variableExpresion.trim().replace('@!', '')
                        hasBeentrimed =true
                    }else if(variableExpresion?.includes('@@')){
                        variableName =variableExpresion?.trim().replace('@@', '')
                        hasBeentrimed =true
                    }
                    // let variableName = variableExpresion.trim().replace('@@', '').replace('@!', '')
                    //esta variable busca el valor en el formulario y si no hay valor entras a conseguir el valor del sistema, en teoria ya no es necesario  ya que para entrar a buscar ahora veo si se hice un trim o no, pero se queda para no pegarle a algo externo
                    let variableValue = this.formValues[variableName] 
                    // if(tipo  == 'radio'){
                    //     console.log({label : variableExpresion, value: variableExpresion} );
                    //     return  {label : variableExpresion, value: variableExpresion}             
                    // }
                    // se agrego el curp como exepcion porque estaba regresando el mismo valor que el campo traia, ocacionando un error ,porque? buena pregunta   
                    if (variableValue == undefined || variableValue== null || variableValue=='' || hasBeentrimed ){
                        // console.lg(variableName);
                        variableValue = this.getValueFromProcessData(variableName)
                    }
                        // return variableValue
                        // if(variableValue != this.formValues[variableName])
                        return variableValue
                }
                if(tipo  == 'radio'){
                    console.log({label : 'Parque', value: variableExpresion} );
                    return  {label : variableExpresion, value: variableExpresion}
                }
               

                return variableExpresion
        },

        getValueFromProcessData(valueReference) {
            let valueRefArray = valueReference.split('->')

            if (valueRefArray.length === 1){
                return this.procedureData[valueRefArray[0]]
            }else if (valueRefArray.length === 2){
                return this.procedureData[valueRefArray[0]][valueRefArray[1]]
            }else if (valueRefArray.length === 3){
                return this.procedureData[valueRefArray[0]][valueRefArray[1]][valueRefArray[2]]
            }else if (valueRefArray.length === 4){
                return this.procedureData[valueRefArray[0]][valueRefArray[1]][valueRefArray[2]][valueRefArray[3]]
            }

            return null
        },

        getLabel(field){
            if (field.validacion.required){
                return '* ' + field.etiqueta
            }

            return field.etiqueta
        },

        /** END FORM ITEMS CREATOR **/

        findApiAjaxDependent(field){
            if (this.apiAjaxComponents[field.nombre] !== undefined){
                return this.apiAjaxComponents[field.nombre]
            }

            return null
        },

        addAndPrepareApiAjax(field){
            field.extra.get_campos.forEach((fieldDependent, index) => {
                let configApiAjaxItem = {
                    originFieldId: field.id,
                    originFieldName: field.nombre,
                    elementType: field.extra.get_tipo[index],
                    event: field.extra.get_valores[index]
                }

                let fieldDependentFinal = fieldDependent.replace(/@/g, '');
                if (this.apiAjaxComponents[fieldDependentFinal] === undefined){
                    Vue.set(this.apiAjaxComponents, fieldDependentFinal, configApiAjaxItem)
                }
            })
        }
    }
}
</script>

<style >

</style>